import { render, staticRenderFns } from "./PostCardBenefist.vue?vue&type=template&id=3c4793b0"
import script from "./PostCardBenefist.vue?vue&type=script&lang=js"
export * from "./PostCardBenefist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports